import { useForm } from '@inertiajs/inertia-react';
import Layout from 'app/components/Layouts/Layout';
import { UserType } from 'app/components/Types/UserType';
import { ChangeImage } from 'app/fragments/Forms/ChangeImage';
import Form from 'app/fragments/Forms/Form';
import PasswordField from 'app/fragments/Forms/PasswordField';
import Submit from 'app/fragments/Forms/Submit';
import TextField from 'app/fragments/Forms/TextField';
import React, { useState } from 'react'
import route from 'ziggy-js';

interface Props {

}

function New(props: Props) {
    const { } = props

    // const { user_detail } = usePageProps<{ user: UserType }>();

    const form = useForm({

    });
    const { data, post } = form;

    const [user, setUser] = useState<{ user: UserType, password: string } | null>(null)

    const submit = (e) => {
        e.preventDefault();
        post(route('user.store'), {
            onSuccess: (res: any) => { console.log(res); setUser(res.props.flash) }
        });
    }

    return (
        <Layout heading='Profile'>
            <div className='w-full flex  flex-col '>
                <h2 className="text-24 font-bold my-40px">Nový uživatel</h2>
                <div className='flex justify-center'>
                    <div className='p-20px  relative bg-gray rounded-default w-1/2  mob:w-full flex justify-center items-center'>
                        {
                            user ? <div className='flex flex-col gap-12px p-30px bg-gray shadow-lg  z-50 rounded text-h2 font-semibold'>
                                <div className='bg-gray-darker p-16px rounded'>UUID: {user?.user?.UUID}</div>
                                <div className='bg-gray-darker p-16px rounded'>Name: {user?.user?.name}</div>
                                <div className='bg-gray-darker p-16px rounded'>Email: {user?.user?.email}</div>
                                <div className='bg-gray-darker p-16px rounded text-16 text-red-600'>Please note down the password, it won't be visible ever again.</div>
                                <div className='bg-gray-darker p-16px rounded' title='Password is visible only in this step.'>Password: <span className='font-bold text-orange-500'>{user?.password}</span></div>
                            </div>
                                :
                                <Form form={form} onSubmit={submit} className="w-full">
                                    <div className='flex gap-20px w-full'>
                                        {/* <div className='w-3/5 grow'>
                                    <ChangeImage name="thumbnail" label="Avatar" image={undefined} height="grow" />
                                </div> */}
                                        <div className='w-full'>
                                            {/* <TextField name="UUID" label="UUID" readOnly className='pointer-events-none' /> */}
                                            <TextField name="name" label="Name" />
                                        </div>
                                    </div>

                                    <TextField name="email" label="Email" />
                                    {/* <PasswordField name="current_password" label="Current password" /> */}
                                    {/* <PasswordField name="password" label="New password" />
                            <PasswordField name="password_confirmation" label="Password confirmation" /> */}
                                    <Submit className='w-full' value="Save" />
                                </Form>
                        }
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default New
